import { useNavigate } from 'react-router-dom';
import { Stethoscope, Library, ChevronRight } from 'lucide-react';

interface ExploreCardsProps {
  plantCount: number;
}

export function ExploreCards({ plantCount }: ExploreCardsProps) {
  const navigate = useNavigate();

  const cards = [
    {
      icon: Stethoscope,
      title: 'Diagnosticar saúde',
      desc: 'Fotos para detectar pragas e doenças',
      onClick: () => navigate('/identify'),
      color: 'text-destructive',
      bg: 'bg-destructive/10',
    },
    {
      icon: Library,
      title: 'Minha coleção',
      desc: `${plantCount} ${plantCount === 1 ? 'planta cadastrada' : 'plantas cadastradas'}`,
      onClick: () => navigate('/collection'),
      color: 'text-primary',
      bg: 'bg-primary/10',
    },
  ];

  return (
    <section className="px-4 py-2">
      <div className="max-w-lg mx-auto space-y-2">
        <h3 className="text-sm font-semibold text-foreground px-1">Continue explorando</h3>
        {cards.map((c, i) => (
          <button
            key={i}
            onClick={c.onClick}
            className="w-full flex items-center gap-3 p-3 rounded-xl bg-card border border-border hover:border-primary/40 transition-colors press-scale text-left"
          >
            <div className={`w-10 h-10 rounded-lg ${c.bg} flex items-center justify-center flex-shrink-0`}>
              <c.icon className={`h-5 w-5 ${c.color}`} />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-sm font-medium text-foreground">{c.title}</p>
              <p className="text-xs text-muted-foreground truncate">{c.desc}</p>
            </div>
            <ChevronRight className="h-4 w-4 text-muted-foreground flex-shrink-0" />
          </button>
        ))}
      </div>
    </section>
  );
}
